export default "__VITE_ASSET__C6DuIY3R__"